module.exports = __webpack_public_path__ + "static/media/invitation.0f1031c8.jpg";